import React, { Fragment, useRef } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Input, FormGroup, Label } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"
import { useEffect } from "react"
import { useState } from "react"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import Flatpickr from "react-flatpickr";


// Define a default UI for filtering
function GlobalFilter({
  setGlobalFilter,
  isJobListGlobalFilter,
  filterData,
  value,
  setValue,
}) {
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
    filterData(value)
  }, 200)

  return (
    <React.Fragment>
      <Col md={12}>
        <div className="search-box w-full d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value)
                  onChange(e.target.value)
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={"Search…"}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}

const PurchaseTable = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddMakingList,
  handleCreatePurchaseClick,
  className,
  filterData,
  pagePerSize,
  isLoading,
  TotalRecords,
  userFilter, setUserFilter,
  vendorFilter, setVendorFilter,
  setDateFilter, dateFilter, users,
  setdateDisble, dateDisble, writeDataToExcel, vendors
  , handleMakePayment, amountData, setIsPurchase, isPurchase
  , isPaid, setIsPaid, handleDeletePurchaseTransaction, setPurchaseTransactionIds
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: 20,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )
  const handlesort = column => { }
  const [pageIndex, setpageIndex] = useState(1)
  const [prevValue, setPrevValue] = useState();


  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    gotoPage(page)
  }

  const [isMobile, setisMobile] = useState(window.innerWidth < 924)
  const [value, setValue] = React.useState()
  const [displaySubAdmin, setDisplaySubAdmin] = useState(false)
  const [isIpad, setIsIpad] = useState(window.innerWidth < 924)

  useEffect(() => {
    pagePerSize(pageSize, pageIndex, value)
    setPrevValue(value);
  }, [pageSize, value, pageIndex])

  useEffect(() => {
    if (value !== prevValue) {
      setpageIndex(1);
    }
  }, [value]);

  useEffect(() => {
    setpageIndex(1);
  }, [pageSize]);

  const margin = {
    marginTop: isMobile ? "" : "",
  }

  const handleClick = () => {
    setdateDisble(!dateDisble);
  }
  const checkbox = useRef();
  const flatpickrRef = useRef(null);

  return (
    <Fragment>
      <Row className="">
        <Col md={6}>
          <Row>
            <Col md={4} className="table-header" style={{ marginBottom: isMobile ? "10px" : '' }}>
              <select
                className="form-select"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={4} className="table-header" style={margin}>
              {isGlobalFilter && (
                <GlobalFilter
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  globalFilter={state.globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  isJobListGlobalFilter={isJobListGlobalFilter}
                  filterData={filterData}
                  value={value}
                  setValue={setValue}
                />
              )}
            </Col>
            {(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") &&
              <Col md={4} className="table-header" style={{ paddingLeft: isIpad ? "" : "0px", marginBottom: isIpad ? "10px" : '' }} >
                <Input
                  disabled={isPurchase == 3 || isPurchase == 2}
                  type="select"
                  id="validationCustom01"
                  className="form-control"
                  name="user"
                  // onChange={validation.handleChange}
                  onChange={e => {
                    setUserFilter(e.target.value)
                  }}
                  value={userFilter}
                >
                  <option value={0}>Select User</option>
                  {users.map((item, index) => {
                    return (
                      <option key={index} value={item.Key}>
                        {item.Value}
                      </option>
                    )
                  })}
                </Input>
              </Col>}
          </Row>
          <Row>
            <Col md={4} className="table-header" style={{ marginBottom: isIpad ? "10px" : '' }} >
              <Input
                disabled={isPurchase == 3}
                type="select"
                id="validationCustom01"
                className="form-control"
                name="vendor"
                // onChange={validation.handleChange}
                onChange={e => {
                  setVendorFilter(e.target.value)
                }}
                value={vendorFilter}
              >
                <option value={0}>Select Vendor</option>
                {vendors.map((item, index) => {
                  return (
                    <option key={index} value={item.Key}>
                      {item.Value}
                    </option>
                  )
                })}
              </Input>
            </Col>
            <Col md={8} className="table-header" style={{ marginBottom: isMobile ? "10px" : '' }}>
              <FormGroup className="mb-2">
                <div className="d-flex" >
                  <div className="form-control " onClick={() => handleClick()} style={{ width: "40px", borderRight: "none", backgroundColor: "#EFF2F7", display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <input
                      id="checkbox"
                      type="checkbox"
                      style={{ width: "15px", height: "15px", cursor: "pointer" }}
                      checked={dateDisble || isPurchase == 3}
                      onChange={e => setdateDisble(e.target.checked)}
                      ref={checkbox}
                    />
                  </div>
                  <Flatpickr
                    ref={flatpickrRef}
                    disabled={!dateDisble || isPurchase == 3}
                    className="form-control d-block"
                    placeholder="dd M,yyyy"
                    options={{
                      mode: "range",
                      dateFormat: "d-m-Y"
                    }}
                    value={dateFilter}
                    onChange={(e) => { setDateFilter(e) }}

                  />
                  <i
                    className="fas fa-calendar-alt calander-icon"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      flatpickrRef.current.flatpickr.open();
                    }}
                  ></i>
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") &&
              <Col md={6} className="table-header mb-2" style={{ display: "flex", justifyContent: "start", marginBottom: isMobile ? "10px" : '' }}>
                <div>
                  <div className=" d-flex gap-2">
                    <Input
                      type="radio"
                      value={1}
                      id="purchase"
                      className="form-check-input"
                      checked={parseInt(isPurchase) == 1}
                      onClick={() => { setIsPurchase(1), setPurchaseTransactionIds([]) }}
                    />
                    <Label className="form-check-label font-size-13 me-2" htmlFor="purchase">
                      Purchase
                    </Label>
                    <Input
                      type="radio"
                      value={2}
                      id="transaction"
                      className="form-check-input"
                      checked={parseInt(isPurchase) == 2}
                      onClick={() => { setIsPurchase(2), setPurchaseTransactionIds([]) }}
                    />
                    <Label className="form-check-label font-size-13  me-2" htmlFor="transaction">
                      Transaction
                    </Label>
                    <Input
                      type="radio"
                      value={3}
                      id="vendor"
                      className="form-check-input"
                      checked={parseInt(isPurchase) == 3}
                      onClick={() => { setIsPurchase(3), setdateDisble(true), setPurchaseTransactionIds([]) }}
                    />
                    <Label className="form-check-label font-size-13" htmlFor="vendor">
                      Vendors
                    </Label>
                  </div>
                </div>
              </Col>
            }

            <Col md={3} className="mb-2" style={{ marginBottom: isMobile ? "10px" : '' }}>
              <Input
                type="checkbox"
                disabled={isPurchase == 2 || isPurchase == 3}
                className="form-check-input"
                id="paid"
                style={{ marginLeft: "13px", marginRight: "8px" }}
                defaultChecked={isPaid}
                onChange={e => setIsPaid(e.target.checked)}
              />
              <Label className="form-check-label font-size-13" htmlFor="paid">
                Paid
              </Label>
            </Col>
          </Row>
        </Col>

        <Col md={6}>
          <Row style={{ fontSize: "14px", textAlign: "end" }}>
            <Col md={6} className='' style={{ fontSize: "14px", textAlign: "end", display: "flex", justifyContent: "end" }} >
              <table className="text-end">
                <tr style={{ textAlign: "end" }}>
                  <th className="">
                    <Label>
                      Cash Paid:
                    </Label>
                  </th>
                  <th className="" style={{ color: "green" }}>  <i className="mdi mdi-currency-inr p-0"></i>
                    {new Intl.NumberFormat('en-IN', {
                      currency: 'INR',
                      minimumFractionDigits: 2,
                    }).format(amountData?.TotalCashAmount || 0)}
                  </th>
                </tr>
                <tr style={{ textAlign: "end" }}>
                  <th className="">
                    <Label>
                      Pvt. Ltd. Paid:
                    </Label>
                  </th>
                  <th className="" style={{ color: "green" }}>  <i className="mdi mdi-currency-inr p-0"></i>
                    {new Intl.NumberFormat('en-IN', {
                      currency: 'INR',
                      minimumFractionDigits: 2,
                    }).format(amountData?.TotalPvtLtdAmount || 0)}
                  </th>
                </tr>
                <tr style={{ textAlign: "end" }}>
                  <th className="">
                    <Label>
                      Total Kiara Paid:
                    </Label></th>
                  <th className="" style={{ color: "green" }}>  <i className="mdi mdi-currency-inr p-0"></i>
                    {new Intl.NumberFormat('en-IN', {
                      currency: 'INR',
                      minimumFractionDigits: 2,
                    }).format(Math.round(amountData?.TotalKiaraAmount || 0))}
                  </th>
                </tr>
              </table>
            </Col>
            <Col md={6} className='' style={{ fontSize: "14px", textAlign: "end", display: "flex", justifyContent: "end" }} >
              <table className="text-end">
                <tr style={{ textAlign: "end" }}>
                  <th className="">
                    <Label>
                      Total Billing:
                    </Label>
                  </th>
                  <th className="" style={{ color: "Blue" }}>  <i className="mdi mdi-currency-inr p-0"></i>
                    {new Intl.NumberFormat('en-IN', {
                      currency: 'INR',
                      minimumFractionDigits: 2,
                    }).format(amountData?.TotalAmount || 0)}
                  </th>
                </tr>
                <tr style={{ textAlign: "end" }}>
                  <th className="">
                    <Label>
                      Total Paid Amt.(-):
                    </Label>
                  </th>
                  <th className="" style={{ color: "green" }}>  <i className="mdi mdi-currency-inr p-0"></i>
                    {new Intl.NumberFormat('en-IN', {
                      currency: 'INR',
                      minimumFractionDigits: 2,
                    }).format(amountData?.TotalPaidAmount || 0)}
                  </th>
                </tr>
                <tr style={{ textAlign: "end" }}>
                  <th className="">
                    <Label>
                      Due Amt.:
                    </Label></th>
                  <th className="" style={{ color: "#d53e3e" }}>  <i className="mdi mdi-currency-inr p-0"></i>
                    {new Intl.NumberFormat('en-IN', {
                      currency: 'INR',
                      minimumFractionDigits: 2,
                    }).format(Math.round(amountData?.TotalUnpaidAmount || 0))}
                  </th>
                </tr>
              </table>
            </Col>
          </Row>
          <div className="d-flex mb-1 mt-1" style={{ justifyContent: isIpad ? "end" : "end", gap: "15px", marginLeft: isIpad ? "6px" : "0px" }}>
            {isPurchase != 3 &&
              <>
                <div style={margin}>
                  <Button
                    title='Delete'
                    className="btn btn-pdf"
                    // color="primary"
                    type="button"
                    onClick={handleDeletePurchaseTransaction}
                  >
                    {/* Export */}
                    <i className="fas fa-trash-alt font-size-16"></i>
                  </Button>
                </div>
              </>
            }
            <div className="text-sm-end">
              <Button
                type="button"
                color="primary"
                className="btn  mb-2 "
                onClick={handleMakePayment}
              >
                Make Payment
              </Button>
            </div>
            <div style={margin}>
              {data.length > 0 ? (<button
                type="button"
                className="btn btn-excel  btn-label"
                onClick={writeDataToExcel}
              >
                Excel <i className="far fa-file-excel label-icon"></i>
              </button>) : (<button
                type="button"
                className="btn  btn-excel  btn-label"
                style={{ cursor: "not-allowed" }}
              >
                Excel <i className="far fa-file-excel label-icon"></i>
              </button>)}
            </div>

            <div className="text-sm-end">
              <Button
                type="button"
                color="primary"
                className="btn  mb-2 "
                onClick={handleCreatePurchaseClick}
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                Create
              </Button>
            </div>
          </div>
        </Col>
      </Row>

      <div className="table-responsive react-table">
        <Table bordered  {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => {
                      handlesort(column)
                    }}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                      },
                    })}
                  >
                    <div className={`mb-0`}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length ? (
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {row.cells.map(cell => {
                        const { IsPaid } = cell.row.original;
                        return (
                          <td
                            key={cell.id}
                            className={`${IsPaid ? "paid-bill" : ""} text-nowrap`}
                            {...cell.getCellProps({
                              style: {
                                minWidth: cell.minWidth,
                                maxWidth: cell.maxWidth,
                                width: cell.width,
                                // backgroundColor: 
                              },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })}
            </tbody>
          ) : (
            <tbody
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
            >
              <tr>
                <td colSpan={headerGroups[0].headers.length}>
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex - 1)}
              disabled={pageIndex == 1}
            >
              {"<<"}
            </Button>
            {/* <Button
              color="primary"
              onClick={previousPage}
              // disabled={!canPreviousPage}
            >
              {"<"}
            </Button> */}
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page
          <strong style={{ marginLeft: "5px" }}>
            {TotalRecords == 0 ? 1 : pageIndex} of {TotalRecords == 0 ? 0 : Math.ceil(TotalRecords / pageSize)}
          </strong> | Total <strong>{TotalRecords}</strong>
        </Col>
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            {/* <Button color="primary" onClick={nextPage} disabled={!canNextPage}> */}
            {/* <Button color="primary" onClick={pageIndex}>
              {">"}
            </Button> */}
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex + 1)}
              disabled={pageIndex == (pageIndex == 1 && TotalRecords == 0 ? Math.ceil(TotalRecords / pageSize) + 1 : Math.ceil(TotalRecords / pageSize))}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

PurchaseTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default PurchaseTable
